import {AuthNav} from 'wicomp-auth'
import {AnalyticsNav} from 'wicomp-analytics'

export default [
   { type: 'heading', name: 'MAIN'},
   // { icon: 'fa fa-columns',component: 'Dashboard', resource: 'visualization', has_permission: true},
   // { 
   //    icon: 'fa fa-paint-roller',component: 'Dashboard', name: 'Advanced UI', has_permission: true,
   //    children: [
   //       { icon: 'fa fa-columns',component: 'Widgets', name: 'Widgets', resource: 'visualization', has_permission: true},
   //       { icon: 'fa fa-columns',component: 'Widgets', name: 'Widgets', resource: 'dashboard', has_permission: true},
   //    ]
   // },
   ...AnalyticsNav,
   ...AuthNav,
]